import React, { useState } from 'react';
import Header from './Header';
import SideNav from './SideNav';
import './Layout.css';

const Layout = ({ children }) => {
    const [sideNavOpen, setSideNavOpen] = useState(false);

    const toggleSideNav = () => {
        setSideNavOpen(!sideNavOpen);
    };

    const closeSideNav = () => {
        setSideNavOpen(false);
    };

    return (
        <div className="app-layout">
            <Header toggleSideNav={toggleSideNav} />
            <SideNav isOpen={sideNavOpen} onClose={closeSideNav} />
            <main className="main-content">
                <div className="page-container">
                    {children}
                </div>
            </main>
        </div>
    );
};

export default Layout;
